import React, { ReactElement } from "react";
import styled from "styled-components";

interface Props {
  isChecked: boolean;
  setIsChecked: React.Dispatch<React.SetStateAction<boolean>>;
  text: string;
  text2?: string;
}

export default function SlideButton({
  isChecked,
  setIsChecked,
  text,
  text2,
}: Props): ReactElement {
  return (
    <Container>
      <div className="text-label">{text}</div>

      <label className="switch glow-on-hover" style={{ marginTop: "2px" }}>
        <input
          type="checkbox"
          checked={isChecked}
          onChange={(e) => {
            setIsChecked(!isChecked);
          }}
        />
        <span className="slider round"></span>
      </label>
      <div className="text-label">{text2}</div>
    </Container>
  );
}

const Container = styled.div`
  display: flex;

  .text-label {
    margin-top: 5px;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 56px;
    height: 30px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #0c0b0b;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 22px;
    width: 22px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: #10e922;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #10e922;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .glow-on-hover {
    /* width: 150px; */
    /* height: 50px; */
    border: none;
    outline: none;
    /* color: #fff; */
    /* background: #111; */
    cursor: pointer;
    position: relative;
    z-index: 0;
    /* border-radius: 10px; */
  }

  .glow-on-hover:before {
    content: "";
    position: absolute;
    top: -2px;
    left: -2px;
    background-size: 400%;
    z-index: -1;
    filter: blur(5px);
    width: calc(100% + 4px);
    height: calc(100% + 4px);
    animation: glowing 20s linear infinite;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    border-radius: 10px;
  }

  .glow-on-hover:active {
    /* color: #000; */
  }

  .glow-on-hover:active:after {
    background: transparent;
  }

  .glow-on-hover:hover:before {
    opacity: 1;
  }

  .glow-on-hover:after {
    z-index: -1;
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    /* background: #111; */
    left: 0;
    top: 0;
    border-radius: 10px;
  }

  @keyframes glowing {
    0% {
      background-position: 0 0;
    }
    50% {
      background-position: 400% 0;
    }
    100% {
      background-position: 0 0;
    }
  }
`;
